<svelte:head>
  <title>{data?.name || 'Offer'} | A Good Thing</title>
</svelte:head>

{#if data}
  {#if request}
    {#if request.status === 'withdrawn'}
      <article class="message is-info">
        <div class="message-body">
          You withdrew your request for this offer.
        </div>
      </article>
    {:else if request.status === 'unsuccessful'}
      <article class="message is-info">
        <div class="message-body">
          Unfortunately, your request was unsuccessful. The business selected
          another local charity for this offer.
        </div>
      </article>
    {:else if request.status === 'completed'}
      <article class="message is-success">
        <div class="message-body">This request has been completed.</div>
      </article>
    {:else if request.status === 'matched'}
      <article class="message is-success">
        <div class="message-body">
          <p class="block">It's a match!</p>
          <p class="block">
            Now it's over to you to complete the donation by arranging
            collection or delivery.
          </p>
          <p class="block">
            We've sent an email to both you and the business contact to get you
            started. If you need any assistance, please contact <a
              href="mailto:support@agoodthing.org.uk"
              >support@agoodthing.org.uk</a>
          </p>
          <!-- svelte-ignore a11y-missing-attribute -->
          <p class="block">
            When the donation has been received, please
            <a
              on:click={() => {
                $uiState.activeModal = {
                  component: ConfirmComplete,
                  props: { requestId }
                };
              }}>mark this request as completed</a
            >.
          </p>
        </div>
      </article>
    {:else if request.status === 'selected'}
      <article class="message is-success">
        <div class="message-body">
          Great news! Your request has been selected!
          <!-- svelte-ignore a11y-missing-attribute -->
          <a
            on:click={() =>
              ($uiState.activeModal = {
                component: ConfirmFinal,
                props: { offerId: id, requestId }
              })}>Confirm the request</a
          >.
        </div>
      </article>

      <div class="box">
        <div class="columns">
          <div class="column">
            <p class="block is-size-4">Confirm your request</p>
            <p class="block">
              Please review the details below. If you're happy to proceed then
              we will put you in touch with the business to complete the
              donation.
            </p>
          </div>

          <!-- Right side -->
          <div class="column is-narrow">
            <button
              class="button is-primary"
              on:click={() =>
                ($uiState.activeModal = {
                  component: ConfirmFinal,
                  props: { offerId: id, requestId }
                })}>Yes, please put me in touch</button
            >&nbsp;
            <button
              class="button"
              on:click={() =>
                ($uiState.activeModal = {
                  component: ConfirmWithdraw,
                  props: { offerId: id, requestId }
                })}>No thanks, I've changed my mind</button>
          </div>
        </div>
      </div>
    {:else if request.status === 'interested'}
      <article class="message is-success">
        <div class="message-body">
          Your message has been sent to the business.
        </div>
      </article>
    {:else}
      <article class="message is-success">
        <div class="message-body">
          Your request has been sent. We'll let you know whether it is selected.
          Good luck!
        </div>
      </article>
    {/if}

    {#if request.status === 'selected' || request.status === 'matched'}
      <div class="box">
        <div class="columns">
          <div class="column">
            <p class="is-size-4">Business making the offer</p>
            <table class="table is-fullwidth">
              <thead>
                <tr>
                  <th style="width:200px" />
                  <th />
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Name</td>
                  <td>{request.company ? request.company.name : ''}</td>
                </tr>
                <tr>
                  <td>Website</td>
                  <td><a href={safeWebsite(request.company?.website)}>{request.company?.website}</a></td>
                </tr>
                <tr>
                  <td>Postcode</td>
                  <td>
                    {request.company?.postcode}
                    <a
                      target="_new"
                      href="https://www.google.co.uk/maps/search/{request
                        .company?.postcode}">
                      Open in Google Maps
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="box">
        <p class="is-size-4">Contact details</p>
        {#if request.status === 'matched'}
          <table class="table is-fullwidth">
            <thead>
              <tr>
                <th style="width:200px" />
                <th />
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Name</td>
                <td>
                  {request.company?.contact?.firstName}
                  {request.company?.contact?.lastName}
                </td>
              </tr>
              <tr>
                <td>Email</td>
                <td>{request.company?.contact?.email}</td>
              </tr>
            </tbody>
          </table>
        {:else}
          <p class="block">
            Full contact details will be shared when you confirm your request.
          </p>
        {/if}
      </div>

      <hr />
    {/if}
  {:else if !isOfferActive}
    <article class="message is-danger">
      <div class="message-body">Sorry, this offer is no longer available.</div>
    </article>
  {:else if data.paused}
    <article class="message is-danger">
      <div class="message-body">This offer is currently paused and not accepting requests. Try checking back later.</div>
    </article>
  {/if}

  <div class="columns">
    <div class="column is-narrow">
      {#if data.images?.[0]}
        <img
          alt="Offer"
          on:click={() => {
            $uiState.activeModal = {
              component: Lightbox,
              props: { images: data.images, index: 0 }
            };
          }}
          src={data.images[0]}
          style="width:240px; cursor:pointer;" />
      {:else}
        <img
          alt="Generic"
          src="/assets/img/box.png"
          style="height:240px;width:240px; background-color:lightgrey" />
      {/if}
      <div style="width:250px;">
        {#if data.images?.length > 1}
          {#each data.images as url, index}
            {#if index !== 0}
              <div style="display:inline-block;margin-right: 8px;">
                <img
                  alt="Offer"
                  on:click={() => {
                    $uiState.activeModal = {
                      component: Lightbox,
                      props: { images: data.images, index }
                    };
                  }}
                  src={url}
                  style="max-width:116px;" />
              </div>
            {/if}
          {/each}
        {/if}
      </div>
    </div>

    <div class="column">
      <h2 class="block title">{data.name}</h2>

      <div class="block">
        <!-- Left side -->
        <div class="level-left">
          {#if isChatEnabled && !request && isOfferActive}
            <button
              class="button is-secondary mr-2"
              disabled={!canMakeRequests}
              on:click={() =>
                ($uiState.activeModal = {
                  component: ConfirmInterest,
                  props: { item: { id, data } }
                })}>
              Ask the business a question
            </button>
          {/if}
          {#if !request && isOfferActive}
            <button
              class="button is-primary mr-2"
              disabled={!canMakeRequests || data.paused}
              on:click={() =>
                ($uiState.activeModal = {
                  component: ConfirmRequest,
                  props: { item: { id, data }, distance: milesApart}
                })}>
              Request
            </button>
          {:else if request && isOfferActive && request.status === 'interested'}
            <button
              class="button is-primary mr-2"
              disabled={!canMakeRequests || data.paused}
              on:click={() => setRequestStatusToNew()}>
              Request
            </button>
          {/if}
          {#if request && request.status === 'new'}
            <button
              class="button"
              on:click={() =>
                ($uiState.activeModal = {
                  component: ConfirmWithdraw,
                  props: { offerId: id, requestId }
                })}>
              Withdraw request
            </button>
          {/if}
        </div>
      </div>

      {#if createdDatePhrase}
        <p class="block has-text-grey-light">Published {createdDatePhrase}</p>
      {/if}

      {#if data.options?.nationwide || data.options?.divisible}
        <div class="block">
          {#if data.options?.nationwide}
            <span class="tag is-info is-medium">
              Offered nationwide via post
            </span>
          {/if}
          {#if data.options?.divisible}
            <span class="tag is-warning is-medium">Can be split</span>
          {/if}
        </div>
      {/if}

      <p class="block" style="white-space:pre-wrap;">{data.description}</p>

      {#if !isChatEnabled}
        <hr />
      {/if}

      {#if isChatEnabled}
        <div class="tabs">
          <ul>
            <li
              class:is-active={!showMessages}
              on:click={() => {
                if (showMessages) {
                  showMessages = false;
                }
              }}>
              <!-- svelte-ignore a11y-missing-attribute -->
              <a> Business Profile </a>
            </li>
            {#if request && requestMessages && requestMessages.length > 0}
              <li
                class:is-active={showMessages}
                on:click={() => {
                  if (!showMessages) {
                    showMessages = true;
                  }
                }}>
                <!-- svelte-ignore a11y-missing-attribute -->
                <a> Messages </a>
              </li>
            {/if}
          </ul>
        </div>
      {/if}
      {#if !showMessages || !isChatEnabled}
        <div class="block is-size-4">
          Offered by a business {readableDistance}
        </div>

        {#if data.location}
          <div class="block">
            <Map location={data.location} drawCircle />
          </div>
        {/if}
        <hr />
      {/if}

      {#if isChatEnabled && showMessages}
        <Chat
          messageIds={requestMessages ?? []}
          isBusiness={false}
          charityName={$appState.charity?.name}
          companyName={request.company?.name ?? ''} />
      {/if}
    </div>
  </div>
{/if}

<script lang="ts">
  export let id: string;
  import _ from 'lodash';
  import getFeatureFlags from '../../../utils/getFeatureFlags';
  import { appState } from '../../../lib/appState';
  import { uiState } from '../../../lib/uiState';
  import { params } from '@sveltech/routify';
  import ConfirmRequest from './_components/ConfirmRequest.svelte';
  import ConfirmFinal from './_components/ConfirmFinal.svelte';
  import ConfirmInterest from './_components/ConfirmInterest.svelte';
  import ConfirmComplete from './_components/ConfirmComplete.svelte';
  import ConfirmWithdraw from './_components/ConfirmWithdraw.svelte';
  import Lightbox from '../../_components/Lightbox.svelte';
  import Map from '../../_components/MapJS.svelte';
  import dayjs from 'dayjs';
  import relativeTime from 'dayjs/plugin/relativeTime';
  import { safeWebsite } from '../../../lib/utils';

  dayjs.extend(relativeTime);

  import geoDist from 'geo-dist';
  import Chat from '../../_components/Chat.svelte';

  const { isChatEnabled } = getFeatureFlags();

  let data: PublishedOffer_v1;
  let requestId: string;
  let request: Request_v2;
  let showMessages = false;
  let isOfferActive = true;

  let firebase = window.firebase;

  $: requestMessages = request?.messages;

  $: readableDistance = formatMiles(milesApart)
  $: milesApart = charityLocation && data && geoPointsToMiles(data.location, {latitude: charityLocation.coordinates[1], longitude: charityLocation.coordinates[0]} )

  $: charityLocation = $appState.charity!.location;

  $: createdDatePhrase = data?.created
    ? dayjs().to(dayjs(data.created))
    : undefined;

  $: canMakeRequests =
    $appState.auth_user?.emailVerified &&
    !!$appState.charity?.isOwnershipVerified;

  $: if (requestId) {
    if ($params.action === 'yes') {
      $uiState.activeModal = {
        component: ConfirmFinal,
        props: { offerId: id, requestId }
      };
    } else if ($params.action === 'no') {
      $uiState.activeModal = {
        component: ConfirmWithdraw,
        props: { offerId: id, requestId }
      };
    }
  }

  get();

  async function get() {
    firebase
      .firestore()
      .collection('published_offers_v1')
      .doc(id)
      .onSnapshot(async (doc) => {
        if (doc.exists) {
          data = doc.data() as PublishedOffer_v1;
          console.log(data);
        } else {
          isOfferActive = false;
          data = (
            await firebase
              .firestore()
              .collection('published_offers_archive_v1')
              .doc(id)
              .get()
          ).data() as PublishedOffer_v1;
        }
      });
  }

  async function getRequestStatus() {
    let firebase = window.firebase;

    firebase
      .firestore()
      .collection('requests_v2')
      .where('offer', '==', id)
      .where('charity.id', '==', $appState.user!.charity)
      .onSnapshot((docs) => {
        console.log(docs.size);
        if (docs.size > 0) {
          requestId = docs.docs[0].id;
          request = docs.docs[0].data() as Request_v2;
          console.log(request);
        }
      });
  }

  getRequestStatus();

  function geoPointsToMiles(point1?: GeoPoint, point2?: GeoPoint): number | undefined {
    if(point1 && point2) {
      return Math.round(geoDist(
        point1.latitude,
        point1.longitude,
        point2.latitude,
        point2.longitude
      ) * 0.6213712);
    }
    return undefined
  }

  function formatMiles(miles?: number): string {
    switch(true){
      case miles == 0:
        return 'within 1 mile'
      case miles && miles > 0:
        return miles + ' miles away';
      default:
        return 'nearby'
    }
  }

  async function setRequestStatusToNew() {
    await firebase.functions().httpsCallable('api-request-updaterequeststatus')({
      requestId,
      status: 'new'
    } as UpdateRequestParams);
  }
</script>
